import { useCallback, useState } from "react";
import type { ProviderInteractionMode, RuntimeMode } from "@cmmd-forge/contracts";

/**
 * How the first turn will run: what the agent may do, and what it may touch.
 *
 * Two independent axes kept together because the composer presents them as one
 * row of controls. Interaction mode toggles rather than being set — there are
 * exactly two states and the control is a switch, so an API that took a value
 * would let a caller set the state it is already in.
 */
export function useDraftTurnModes(): {
  readonly interactionMode: ProviderInteractionMode;
  readonly runtimeMode: RuntimeMode;
  readonly toggleInteractionMode: () => void;
  readonly setRuntimeMode: (next: RuntimeMode) => void;
} {
  const [interactionMode, setInteractionMode] = useState<ProviderInteractionMode>("default");
  const [runtimeMode, setRuntimeMode] = useState<RuntimeMode>("full-access");

  const toggleInteractionMode = useCallback(() => {
    setInteractionMode((current) => (current === "default" ? "plan" : "default"));
  }, []);

  return { interactionMode, runtimeMode, toggleInteractionMode, setRuntimeMode };
}
